const selectorsContactTemplate = {
	form: '#contact_form',
	inputRequired: 'input[data-input-error],textarea[data-input-error]'
}

const classesContactTemplate = {
    error: 'is-error'
}

register('contact-template', {
  onLoad() {
    //validate contact form before submit
    const form = this.container.querySelector(selectorsContactTemplate.form);
    form.setAttribute('novalidate','novalidate');
    form.addEventListener('submit', (e) => {
    	const form_inputs = form.querySelectorAll(selectorsContactTemplate.inputRequired);
    	let form_error = false;
    	form_inputs.forEach( input => {
    		let error_el = input.nextElementSibling;
    		const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    		if ( (input.value != '' && input.getAttribute('type') != 'email') || ( input.getAttribute('type') == 'email' && validRegex.test(input.value) ) ) {
    			if ( error_el && error_el.classList.contains('form-input-error') ) {
    				error_el.parentNode.removeChild(error_el);
    			}
                input.classList.remove(classesContactTemplate.error);
    		}else{
                input.classList.add(classesContactTemplate.error);
    			error_el = error_el.classList.contains('form-input-error') ? error_el : document.createElement('span');
    			error_el.innerText = input.getAttribute('data-input-error');
    			error_el.classList.add('form-input-error');
    			input.parentNode.insertBefore(error_el, input.nextSibling);
    			form_error = true;
    		}
    	})
    	if (form_error) {
    		e.preventDefault();
    		return false;
    	}

    })
  },
  onUnload() {
    this.$container.off(this.namespace);
  },
});

load('contact-template');